const scrollToTop = (behavior: ScrollBehavior = "smooth") => {
  document.querySelector("main")?.scrollTo({ top: 0, behavior });
};

export { scrollToTop };
